import { isEmpty as _isEmpty } from 'lodash-es';

/**
 * Checks if value is empty. A value is considered empty unless it’s an arguments object, array, string,
 * or jQuery-like collection with a length greater than 0 or an object with own enumerable properties.
 */
export function isEmpty(value: unknown): value is ('' | null | undefined) {
	return _isEmpty(value);
}
